import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { get } from 'lodash';
import React, { FC } from 'react';

// import Schemas
import Schema from '../../../../lib/paths/antrag_FULL_Paths.json';
import PersonSchema from '../../../../lib/paths/person_FULL_Paths.json';
const P = Schema.attributes;
const Person_P = PersonSchema.attributes;

const AnsprechPartnerKontakt: FC<{ open: boolean; onClose: () => void; title?: string; application?: any }> = ({
	open,
	onClose,
	title = 'Haben Sie Fragen? Wir sind für Sie da:',
	application,
}) => {
	const allProjektManager = get(
		application,
		P.Foerderprogramm.schema.attributes.Foerderrichtlinie.schema.attributes.Allgemein_Ansprechperson.path,
		[]
	);

	return (
		<>
			<Dialog open={open} onClose={() => onClose()} sx={{ '& .MuiPaper-root': { width: '40rem', maxWidth: '40rem' } }}>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent>
					<Grid2 container spacing={2}>
						{allProjektManager.map((ele: any, i: number) => {
							return (
								<Grid2 key={i} sm={6}>
									<Typography variant='body1' sx={{ fontWeight: 600 }}>
										{get(ele, Person_P.Personenbezogene_Daten_Vorname.path, '')}{' '}
										{get(ele, Person_P.Personenbezogene_Daten_Nachname.path, '')}{' '}
									</Typography>
									{/* <Typography>
										{get(ele, Person_P.Personenbezogene_Daten_Anrede.path, 'Herr') === 'Herr' ? 'Projektmanager' : 'Projektmanagerin'}
									</Typography> */}
									<Typography>{get(ele, Person_P.Kontaktdaten_Telefon.path, '')}</Typography>
									<Typography>
										<Link href={'mailto:' + get(ele, Person_P.Kontaktdaten_E_Mail.path)}>
											{get(ele, Person_P.Kontaktdaten_E_Mail.path)}
										</Link>
									</Typography>
								</Grid2>
							);
						})}
					</Grid2>
				</DialogContent>
				<DialogActions>
					<Button variant='outlined' onClick={() => onClose()}>
						Schließen
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
export default AnsprechPartnerKontakt;
